export const apiUrl = process.env.REACT_APP_REST_HOST;
